<template>
    <div>
        <div id="msg-div"></div>
        <div>
            <p>
                {{ $t('label.shaparak_request_list') }}
            </p>
        </div>
        <kt-row>
            <kt-col v-if="shaparak_requests && shaparak_requests.length > 0">
                <kt-table is_responsive class="shRequestTable table table-striped" >
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>{{ $t('label.type') }}</th>
                        <th>{{ $t('label.request_date') }}</th>
                        <th>{{ $t('label.response_thacking_number') }}</th>
                        <th>{{ $t('label.status') }}</th>
                        <th>{{ $t('label.response_rejection_reason') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-bind:key="index" v-for="(request, index) in shaparak_requests">
                        <td>{{ request.id }}</td>
                        <td>{{ request.type }}</td>
                        <td>{{request.request_date}}</td>
                        <td>{{ request.response_tracking_number ? request.response_tracking_number : '-' }}</td>
                        <td><div :class="'badge badge-'+ shRequestVariant(request.status)+' text-white'">{{ shRequestStatusStr.get(request.status) }}</div></td>
                        <td>
                            <div v-bind:key="rindex" v-for="(rejection, rindex) in request.response_rejection_reason">
                                <span>{{ rejection.codeExceptionValue }} : {{ rejection.fieldName }}</span>
                            </div>
                        </td>
<!--                        <td v-if="request.response_rejection_reason == null"></td>-->
                    </tr>
                    </tbody>
                </kt-table>
            </kt-col>
            <kt-col v-else class="mb-4">
                <p class="badge badge-warning w-100 p-3 text-dark" style="font-size:1.2em">
                    {{ $t('not_sent_request_to_shaparak_yet') }}
                </p>
                <div class="row">
                    <kt-col lg="5" md="4" sm="3"></kt-col>
                    <kt-col lg="2" md="4" sm="6">
                        <div class="not-found mt-4" style="margin: auto;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 339 287.94">
                                <defs>
                                </defs>
                                <g id="Layer_2" data-name="Layer 2">
                                    <g id="Layer_2-2" data-name="Layer 2">
                                        <path class="cls-1" d="M217.28,125.46V237.62a12,12,0,0,1-12,12h-96a12,12,0,0,1-12-12v-135a12,12,0,0,1,12-12H182S217.85,124.88,217.28,125.46Z"/>
                                        <path class="cls-2" d="M216.88,125.62h-22.6a12,12,0,0,1-12-12V91.37"/>
                                        <path class="cls-1" d="M233.28,141.46V253.62a12,12,0,0,1-12,12h-96a12,12,0,0,1-12-12v-135a12,12,0,0,1,12-12H198S233.85,140.88,233.28,141.46Z"/>
                                        <path class="cls-2" d="M232.88,141.62h-22.6a12,12,0,0,1-12-12V107.37"/>
                                        <circle class="cls-3" cx="231.33" cy="204.63" r="47.51"/>
                                        <path class="cls-3" d="M253.07,229.31a32.89,32.89,0,0,1-46.42-2.94"/>
                                        <path class="cls-3" d="M209.59,180A32.9,32.9,0,0,1,256,182.89"/>
                                        <rect class="cls-3" x="153.63" y="234.17" width="21.93" height="58.47" rx="10.96" transform="translate(253.47 -34.21) rotate(48.63)"/>
                                        <line class="cls-3" x1="185.73" y1="243.17" x2="194.87" y2="235.12"/>
                                        <circle class="cls-4" cx="230.98" cy="204.45" r="36.02"/>
                                        <path class="cls-5" d="M225.35,224.16h-4.67v4.68h4.67Zm-11.63-31.58H243.2a2.24,2.24,0,0,1,2.22,2.22v11.06a2.14,2.14,0,0,1-.66,1.57,2.11,2.11,0,0,1-1.56.65H227.58a6.7,6.7,0,0,0-4.88,2,6.6,6.6,0,0,0-2,4.9v2.4h4.67V215a2.25,2.25,0,0,1,2.23-2.22H243.2a6.9,6.9,0,0,0,6.89-6.9V194.8a6.7,6.7,0,0,0-2-4.93,6.63,6.63,0,0,0-4.87-2l-29.48-.06Z"/>
                                        <line class="cls-6" x1="132.28" y1="152.62" x2="189.28" y2="152.62"/>
                                        <line class="cls-6" x1="132.28" y1="168.62" x2="186.28" y2="168.62"/>
                                        <line class="cls-6" x1="132.28" y1="184.62" x2="173.28" y2="184.62"/>
                                        <line class="cls-6" x1="132.28" y1="200.62" x2="173.28" y2="200.62"/>
                                        <polygon class="cls-7" points="58.18 33.56 55.94 33.56 55.94 38.04 51.47 38.04 51.47 40.28 55.94 40.28 55.94 44.75 58.18 44.75 58.18 40.28 62.65 40.28 62.65 38.04 58.18 38.04 58.18 33.56"/>
                                        <polygon class="cls-7" points="334.52 191.32 332.29 191.32 332.29 195.79 327.81 195.79 327.81 198.03 332.29 198.03 332.29 202.5 334.52 202.5 334.52 198.03 339 198.03 339 195.79 334.52 195.79 334.52 191.32"/>
                                        <polygon class="cls-7" points="23.5 215.93 21.26 215.93 21.26 220.41 16.78 220.41 16.78 222.64 21.26 222.64 21.26 227.12 23.5 227.12 23.5 222.64 27.97 222.64 27.97 220.41 23.5 220.41 23.5 215.93"/>
                                        <polygon class="cls-8" points="278.58 41.4 276.35 41.4 276.35 45.87 271.87 45.87 271.87 48.11 276.35 48.11 276.35 52.58 278.58 52.58 278.58 48.11 283.06 48.11 283.06 45.87 278.58 45.87 278.58 41.4"/>
                                        <circle class="cls-9" cx="175.09" cy="6.15" r="5.03"/>
                                        <circle class="cls-10" cx="6.15" cy="124.75" r="5.03"/>
                                        <circle class="cls-10" cx="332.85" cy="106.85" r="5.03"/>
                                    </g>
                                </g>
                            </svg>
                            <p class="mt-3 mb-5" style="text-align: center; font-size: 1.1rem; color: #444">{{ $t('datatable.records.noRecords') }}</p>
                        </div>
                    </kt-col>
                    <kt-col lg="5" md="4" sm="3"></kt-col>
                    </div>
            </kt-col>
        </kt-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { shRequestStatusStr, shRequestVariant } from '@/constants/shaparakRequestStatus'

export default {
    computed: {
        ...mapGetters('pspRequest', [
            'current_psp_tab',
        ]),
        ...mapGetters('shaparak', [
            'shop_shaparak_requests',
            'shaparak_requests',
        ]),
        shRequestStatusStr() {
            return shRequestStatusStr
        },
        shRequestVariant() {
            return shRequestVariant
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.shaparak_requests = vm.shop_shaparak_requests[vm.current_psp_tab]
        })
    }
}
</script>

<style>
.shRequestTable th, td{
    text-align: center;
}
</style>